// Client layer (TS-2.5.04), pure except for the sessionStorage read/write it exists to wrap.
// Mirrors features/projects/lib/pageSizePreference.ts's shape and rationale exactly (D-259: the
// house has no preference-persistence pattern beyond "wrap every call in try/catch", because
// sessionStorage can throw in private browsing, under quota, or when storage is disabled by
// policy, and losing the remembered choice must never crash the page). This remembers which
// swimlane grouping (Team vs Product, decisions.md D-278) this browser tab last chose for the LIVE
// roadmap, for the current session only - the frozen/archived view (FrozenRoadmapPanel) has no
// toggle and never reads this key.
const STORAGE_KEY = "eg.roadmap.groupMode";

export type RoadmapGroupMode = "team" | "product";

function isGroupMode(value: string): value is RoadmapGroupMode {
  return value === "team" || value === "product";
}

/** Returns the remembered choice for this session, or `null` if none was stored (or storage is unavailable). */
export function readGroupModePreference(): RoadmapGroupMode | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw !== null && isGroupMode(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** Best-effort only: a failure to persist leaves the page working with its in-memory choice. */
export function writeGroupModePreference(value: RoadmapGroupMode): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Ignored: see file header.
  }
}
